import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import SocialLinks from "./social_links";

class ProfileEdit extends Component  {
  constructor(props) {
    super(props);

    this.state = {
      isSocialModalShow: false,
    };
  }

  handleClick = () => {
    this.setState(prevState => (
      { isSocialModalShow: !prevState.isSocialModalShow }
    ));
  };

  render () {
    const { isSocialModalShow } = this.state;
    const { is_mypage, handleEditButtonClick } = this.props;

    return is_mypage === true && (
      <td id='cover-btn' className='d-none d-md-table-cell edit-btns'>
        <button type='button' className='btn btn-outline-light btn-m' data-ga-label='btn-message-head' onClick={handleEditButtonClick}>
          編集
        </button>

        <button type='button' className='btn btn-outline-light btn-m' data-ga-label='btn-message-head' onClick={this.handleClick}>
          SNS連携
        </button>

        <Modal isOpen={isSocialModalShow} toggle={this.handleClick}>
          <ModalHeader toggle={this.handleClick}>SNS連携</ModalHeader>
          <ModalBody>
            <p>連携したSNSアカウントがリンクとして表示されます</p>
            <SocialLinks {...this.props} />
          </ModalBody>
        </Modal>
      </td>
    );
  }
}

ProfileEdit.propTypes = {
  is_mypage: PropTypes.bool.isRequired,
  handleEditButtonClick: PropTypes.func
};

ProfileEdit.defaultProps = {
  handleEditButtonClick: null
};

export default ProfileEdit;
